import type { HTMLAttributes, ReactNode } from "react";
import { DSRadius } from "../foundations/tokens";

/**
 * GlassCard — the primary glass surface. `cornerRadius` defaults to `DSRadius.xl`
 * (16px) with a 1px stroke and `DSSpacing.lg` padding, matching the iOS card.
 */
export interface GlassCardProps extends HTMLAttributes<HTMLElement> {
	readonly children: ReactNode;
	readonly cornerRadius?: number;
	readonly showsStroke?: boolean;
}

export function GlassCard({
	children,
	className = "",
	cornerRadius = DSRadius.xl,
	showsStroke = true,
	style,
	...props
}: Readonly<GlassCardProps>) {
	return (
		<section
			className={`ds-glass-card ${className}`.trim()}
			style={{
				borderRadius: `${cornerRadius}px`,
				border: showsStroke ? undefined : "0",
				...style,
			}}
			{...props}
		>
			{children}
		</section>
	);
}
